import React from 'react'
import classNames from 'classnames'
interface Props {
	prefix?: 'fak' | 'fal' | 'fab' | 'fas' | 'far' | 'fad'
	tabBarIcon: string
	className?: string
}

const TabIcon: React.FC<Props> = ({ prefix = 'fal', tabBarIcon, className }) => (
	<i className={classNames('tab-icon', className, prefix, `fa-${tabBarIcon}`)} />
)

export default TabIcon
